<template>
  <div class="dem-pro-pgto" :class="[ 'venda_numero_pgto' ].indexOf($route.name) !== -1 ? 'sem-dialog' : 'com-dialog'">
    <!-- SETA O STATUS DA TELA -->
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else>
      <div slot='titulo' class="titulo" v-if="[ 'venda_numero_pgto' ].indexOf($route.name) !== -1">
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        NF com pagamentos?

        <App-Toggles :data-time="time" class="app-cpnt-field" :class="campos.informar.id" v-if="dados.p_doc_tp === 'NFe' && dados.nfEmitida === false"
          :cpntStatus='campos.informar.status'
          :cpntId='campos.informar.id'
          :cpntClassDivField='campos.informar.classDivField'
          :cpntNome='campos.informar.nome'
          :cpntValue='campos.informar.value'
          :cpntDisabled='campos.informar.disabled'
          :cpntMostrar='campos.informar.mostrar'
          :cpntMensagem='campos.informar.mensagem'
          :cpntMensagemTipo='campos.informar.mensagemTipo'
          :cpntOn='campos.informar.on'
          :cpntOff='campos.informar.off'
          :cpntExplica='campos.informar.explica'
          :cpntWidth='campos.informar.width'
          :cpntTabIndex='campos.informar.tabIndex'

          :cpntOnChange='campos.informar.onChange'
          :cpntOnBlur='campos.informar.onBlur'
          ref='informar'
        ></App-Toggles>
        
        <span v-else v-html="campos.informar.value === true ? 'Sim' : 'Não'"></span>

        <div class="fechar">
          <App-Button :cpntClass="'btn btn-default'" @onClick="demEdiProDocPagFechar">Voltar</App-Button>
        </div>
      </div>

      <div slot='conteudo' v-if="statusGeral === ''" class="conteudo">
        <table class="dem-edi-pro-doc-pag">
          <tbody v-show="campos.informar.value === true">
            <tr>
              <td class="titulo">
                <!-- SETA O VALOR TOTAL DO CAMPO -->
                Total: R$ <span v-html="demEdiProDocPagValorLiquidoProduto"></span>

                <!-- SETA O TOTAL DE TROCO -->
                <span v-if="[ '', null, undefined, 0 ].indexOf(totais.troco) === -1" class='troco' style="color: red">
                  (Troco: <span v-html="totais._troco"></span>)
                </span>
              </td>
              <td class="troco">
                <div v-if="campos.id_pgto.troco === true && totais.faltante > 0" v-shortkey="[ 'f9' ]" @shortkey="demEdiProDocPagAtalhoTroco"  @click="demEdiProDocPagAtalhoTroco">
                  Calcular troco [F9]
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="2" class="conteudo">
                <!-- SETA A PARTE DO INSERIR -->
                <div class="campos" v-if="linha.length === 0 || totais.faltante > 0">
                  <div :class="campos.dup_vcto.mostrar === true ? 'com-vencimento' : ''">
                    <!-- <App-Input :data-time="time" class="app-cpnt-field" :class="campos.valor.id"
                      :cpntStatus='campos.valor.status'
                      :cpntId='campos.valor.id'
                      :cpntClassDivField='campos.valor.classDivField'
                      :cpntNome='campos.valor.nome'
                      :cpntValue='campos.valor.value'
                      :cpntAutoComplete='campos.valor.autocomplete'
                      :cpntMask='campos.valor.mask'
                      :cpntOptionInicialNome='campos.valor.optionInicialNome'
                      :cpntOptionInicialValue='campos.valor.optionInicialValue'
                      :cpntDisabled='campos.valor.disabled'
                      :cpntMostrar='campos.valor.mostrar'
                      :cpntAutoFocus='campos.valor.autofocus'
                      :cpntMensagem='campos.valor.mensagem'
                      :cpntMensagemTipo='campos.valor.mensagemTipo'
                      :cpntPlaceholder='campos.valor.placeholder'
                      :cpntPosicionar='campos.valor.posicionar'
                      :cpntOnChange='campos.valor.onChange'
                      :cpntOnBlur='campos.valor.onBlur'
                      ref='valor'
                    ></App-Input>

                    <App-Select :data-time="time" class="app-cpnt-field" :class="campos.id_pgto.id"
                      :cpntStatus='campos.id_pgto.status'
                      :cpntId='campos.id_pgto.id'
                      :cpntTabIndex='campos.id_pgto.tabIndex'
                      :cpntNome='campos.id_pgto.nome'
                      :cpntValue='campos.id_pgto.value'
                      :cpntMensagem='campos.id_pgto.mensagem'
                      :cpntMensagemTipo='campos.id_pgto.mensagemTipo'
                      :cpntDisabled='campos.id_pgto.disabled'
                      :cpntMostrar='campos.id_pgto.mostrar'
                      :cpntExplica='campos.id_pgto.explica'
                      :cpntPlaceholder='campos.id_pgto.placeholder'
                      :cpntValueRef='campos.id_pgto.valueRef'
                      :cpntRouter='campos.id_pgto.router'
                      :cpntField='campos.id_pgto.field'
                      :cpntWhere='campos.id_pgto.where'
                      :cpntAddButForm='campos.id_pgto.addButForm'
                      :cpntKeyMostra='campos.id_pgto.keyMostra'
                      :cpntTipoOrder='campos.id_pgto.tipoOrder'
                      :cpntOrder='campos.id_pgto.order'
                      :cpntOptions='campos.id_pgto.options'
                      :cpntKeyValue='campos.id_pgto.keyValue'
                      :cpntSearchMinimo='campos.id_pgto.searchMinimo'
                      :cpntMask='campos.id_pgto.mask'
                      :cpntOptionInicialNome='campos.id_pgto.optionInicialNome'
                      :cpntOptionInicialValue='campos.id_pgto.optionInicialValue'

                      :cpntOnBuscarOptions='campos.id_pgto.onBuscarOptions'
                      :cpntOnChange='campos.id_pgto.onChange'
                      :cpntOnBlur='campos.id_pgto.onBlur'
                      :cpntOnRealizaBusca='campos.id_pgto.onRealizaBusca'
                      :cpntOnKeyPressEnter='campos.id_pgto.onKeyPressEnter'
                      ref="id_pgto"
                    ></App-Select>

                    <App-Calendario :data-time="time" class="app-cpnt-field" :class="campos.dup_vcto.id"
                      :cpntStatus='campos.dup_vcto.status'
                      :cpntId='campos.dup_vcto.id'
                      :cpntClassDivField='campos.dup_vcto.classDivField'
                      :cpntNome='campos.dup_vcto.nome'
                      :cpntValue='campos.dup_vcto.value'
                      :cpntAutoComplete='campos.dup_vcto.autocomplete'
                      :cpntMask='campos.dup_vcto.mask'
                      :cpntDisabled='campos.dup_vcto.disabled'
                      :cpntMostrar='campos.dup_vcto.mostrar'
                      :cpntAutoFocus='campos.dup_vcto.autofocus'
                      :cpntMensagem='campos.dup_vcto.mensagem'
                      :cpntMensagemTipo='campos.dup_vcto.mensagemTipo'
                      :cpntPlaceholder='campos.dup_vcto.placeholder'
                      :cpntPosicionar='campos.dup_vcto.posicionar'
                      :cpntOnChange='campos.dup_vcto.onChange'
                      ref='dup_vcto'
                    ></App-Calendario> -->
                    <!-- ({{ cpntDemData }})
                    ({{ dados.virtual_total }}) -->
                    <!-- ({{ dados.virtual_total }})
                      :cpntDemandaDados="{ vcto: cpntDemData, status_fin: '0', virtual_total: dados.virtual_total, id_rec: '' }" -->
                    <!-- ({{ totais.faltante }}) -->
                    <App-Financeiro-Registrar-Receita-Despesa :key="'val-' + totais.faltante" v-if="totais.faltante !== null" 
                    :cpntTipo="'pgto_docfiscal'"
                    :cpntRefId="cpntDemandaId"
                    :cpntDemandaDados="{ vcto: dados.dem_data_ptbr, status_fin: '0', virtual_total: { produto: { liquido: totais.faltante.toString() }, geral: { liquido: totais.faltante.toString() } }, id_rec: '' }"
                    :cpntOnSalvarDados="demEdiProDocPagInserirPagamento"
                    ></App-Financeiro-Registrar-Receita-Despesa>
                  </div>

                  <!-- <div class="inserir">
                    <App-Button
                      :cpntStatus='botoes.inserir.status' 
                      :cpntId='botoes.inserir.id' 
                      :cpntTexto='botoes.inserir.texto' 
                      :cpntClass='botoes.inserir.class'
                      :cpntMostrar='botoes.inserir.mostrar'
                      :cpntTabIndex='botoes.inserir.tabIndex'
                      @onClick='botoes.inserir.onClick'
                    ></App-Button>
                  </div> -->
                </div>

                <!-- SETA A TABELA DE PAGAMENTOS INSERIDOS -->
                <App-Tabela class="dem-edi-pro-doc-pag-tab" v-show="linha.length >= 1"
                :cpntCheckbox="checkbox"
                :cpntColuna="colunas"
                :cpntLinha="linha"
                :cpntSetarValores="demEdiProDocPagTabSetarLinhas"
                :cpntApiRouter="route"
                :cpntApiWhere="where"
                :cpntApiTabPerOrder="order"
                :cpntApiMethods="method"
                :cpntApiEstruturaQueryGet="estruturaQueryGet"
                @TABELA_MARCAR_CHECKBOX='demEdiProDocPagTabMarcarCheckbox'
                ref="tabela">
                  <!-- SETA O TITULO DA TABELA -->
                  <template v-slot:titulo>
                    <div class="dem-edi-pro-doc-pag-tab-tit">
                      <!-- SETA O TITULO DA TABELA -->
                      <b>Pagamentos realizados (Já pagou R$ {{ totais._pago }})</b>

                      <!-- BOTÃO EXCLUIR -->
                      <button :key="'botaoExcluir--' + botaoExcluir" v-if="botaoExcluir !== null && dados.nfEmitida === false" :disabled="botaoExcluir === 'carregando'" class="btn btn-danger btn-sm" title="Clique aqui para excluir." @click="botaoExcluir">
                        <!-- SETA O STATUS DO BOTÃO -->
                        <App-Status :cpntStatus="botaoExcluir" v-if="botaoExcluir === 'carregando'" style="width: 90%; margin: 0px auto;"></App-Status>

                        <!-- COLOCA O ICONE -->
                        <svg v-else class="fa fa-trash"></svg>
                      </button>
                    </div>
                  </template>

                  <!-- SETA VALOR PAGO -->
                  <template v-slot:col_pago="{ linha }">
                    R$ <span v-html="linha._valor"></span>
                  </template>

                  <!-- SETA VALOR RECEBIDO -->
                  <template v-slot:col_recebido="{ linha }">
                    R$ <span v-html="linha._valor_recebido"></span>
                    <span v-if="[ '', null, undefined, 0 ].indexOf(linha.troco) === -1" class='troco'>
                      (Troco: <span v-html="linha._troco"></span>)
                    </span>
                  </template>

                  <!-- SETA A VENCIMENTO -->
                  <template v-slot:col_dup_vcto="{ linha }">
                    <span v-html="linha.dup_vcto_ptbr" v-if="[ '', null, undefined ].indexOf(linha.dup_vcto_ptbr) === -1"></span>
                    <span v-else>---</span>
                  </template>
                </App-Tabela>

              </td>
            </tr>
          </tbody>
          <tr v-show="campos.informar.value !== true">
            <td class="sem-pagamento">
              <div>
                <App-Icone :cpntTipo="'alerta-amarelo'"></App-Icone>
                <br/>
                Venda sem incidência de pagamentos.
              </div>
            </td>
          </tr>
        </table>

        <!-- SETA OS BOTOES DA TELA -->
        <div class="botoes" v-if="(campos.informar.value === false || (linha.length >= 1 && totais.faltante <= 0)) && dados.nfEmitida === false">
          <App-Button :cpntClass="'btn btn-primary'" @onClick="() => { demEdiProDocPagFechar(true) }">
            <template v-if="dados.virtual_p_doc_acao.emitir === '1'">
              <!-- SETA O ICONE A SER UTILIZADO -->
              <App-Icone :cpntTipo="'emitir'"></App-Icone>

              <!-- SETA A QUEBRA DE LINHA -->
              <br/>

              <!-- SETA O TEXTO DO BOTÃO -->
              <span>Emitir</span>
            </template>
            <template v-else-if="dados.virtual_p_doc_acao.reemitir === '1'">
              <!-- SETA O ICONE A SER UTILIZADO -->
              <App-Icone :cpntTipo="'reemitir'"></App-Icone>

              <!-- SETA A QUEBRA DE LINHA -->
              <br/>

              <!-- SETA O TEXTO DO BOTÃO -->
              <span>Reemitir</span>
            </template>
          </App-Button>

          <App-Button :cpntClass="'btn btn-default'" v-if="$store.state.licenca.NFe_emissor !== 'mi' && dados.p_doc_tp === 'NFe'" @onClick="demEdiProDocPreVisualizar">
            <!-- SETA O ICONE A SER UTILIZADO -->
            <App-Icone :cpntTipo="'emitir'"></App-Icone>

            <!-- SETA A QUEBRA DE LINHA -->
            <br/>

            <!-- SETA O TEXTO DO BOTÃO -->
            <span>Pré-visualização</span>
          </App-Button>
        </div>

        <RF-Dialog v-if="mostrarTroco === true"
        :cpntStatus='statusGeral'
        :cpntLargura='"400px"'
        :cpntTitulo="'Calcular troco para R$ ' + totais._faltante"
        :cpntOnFecharDialog='demEdiProDocPagFechar'>
          <template slot='conteudo'>
            <div class="calc-troco">
              <table>
                <tr>
                  <td>
                    <App-Input :data-time="time" class="app-cpnt-field" :class="campos.recebido.id"
                      :cpntStatus='campos.recebido.status'
                      :cpntId='campos.recebido.id'
                      :cpntClassDivField='campos.recebido.classDivField'
                      :cpntNome='campos.recebido.nome'
                      :cpntValue='campos.recebido.value'
                      :cpntAutoComplete='campos.recebido.autocomplete'
                      :cpntMask='campos.recebido.mask'
                      :cpntOptionInicialNome='campos.recebido.optionInicialNome'
                      :cpntOptionInicialValue='campos.recebido.optionInicialValue'
                      :cpntDisabled='campos.recebido.disabled'
                      :cpntMostrar='campos.recebido.mostrar'
                      :cpntAutoFocus='campos.recebido.autofocus'
                      :cpntMensagem='campos.recebido.mensagem'
                      :cpntMensagemTipo='campos.recebido.mensagemTipo'
                      :cpntPlaceholder='campos.recebido.placeholder'
                      :cpntPosicionar='campos.recebido.posicionar'
                      :cpntOnChange='campos.recebido.onChange'
                      :cpntOnBlur='campos.recebido.onBlur'
                      ref='recebido'
                    ></App-Input>
                  </td>
                  <td>
                    <App-Input :data-time="time" class="app-cpnt-field" :class="campos.troco.id"
                      :cpntStatus='campos.troco.status'
                      :cpntId='campos.troco.id'
                      :cpntClassDivField='campos.troco.classDivField'
                      :cpntNome='campos.troco.nome'
                      :cpntValue='campos.troco.value'
                      :cpntAutoComplete='campos.troco.autocomplete'
                      :cpntMask='campos.troco.mask'
                      :cpntOptionInicialNome='campos.troco.optionInicialNome'
                      :cpntOptionInicialValue='campos.troco.optionInicialValue'
                      :cpntDisabled='campos.troco.disabled'
                      :cpntMostrar='campos.troco.mostrar'
                      :cpntAutoFocus='campos.troco.autofocus'
                      :cpntMensagem='campos.troco.mensagem'
                      :cpntMensagemTipo='campos.troco.mensagemTipo'
                      :cpntPlaceholder='campos.troco.placeholder'
                      :cpntPosicionar='campos.troco.posicionar'
                      :cpntOnChange='campos.troco.onChange'
                      :cpntOnBlur='campos.troco.onBlur'
                      ref='troco'
                    ></App-Input>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <div class="inserir">
                      <App-Button
                        :cpntStatus='botoes.inserir.status' 
                        :cpntId='botoes.inserir.id' 
                        :cpntTexto='botoes.inserir.texto' 
                        :cpntClass='botoes.inserir.class'
                        :cpntMostrar='botoes.inserir.mostrar'
                        :cpntTabIndex='botoes.inserir.tabIndex'
                        @onClick='() => { demEdiProDocPagInserirTroco() }'
                      ></App-Button>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </template>
        </RF-Dialog>

        <RF-Dialog v-if="[ '', null, undefined ].indexOf(previsualizar) === -1"
        :cpntStatus='(previsualizar === "carregando" || (previsualizar !== "carregando" && typeof previsualizar !== "string")) ? previsualizar : ""'
        :cpntLargura='"900px"'
        :cpntTitulo="'Pré-visualização da NF-e'"
        :cpntOnFecharDialog='demEdiProDocPreVisualizarFechar'>
          <template slot='conteudo'>
            <embed :src="'data:application/pdf;base64, ' + previsualizar" width="100%" height="100%" style="height: 100vh;" type="application/pdf">
          </template>
        </RF-Dialog>
      </div>
    </template>
  </div>
</template>

<style scoped>
.dem-pro-pgto {
  max-width: 600px;
  margin: 0px auto;
} 
.dem-pro-pgto.sem-dialog {
  padding: 10px;
  padding-bottom: 250px;
}
  .dem-pro-pgto.sem-dialog > .titulo {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #e9e9e9;
  }
    .dem-pro-pgto.sem-dialog > .titulo > .fechar {
      float: right;
    }
      .dem-pro-pgto.sem-dialog > .titulo > .fechar > button {
        width: 80px;
        /* vertical-align: -3px; */
        margin-top: -2px;
      }

    .dem-pro-pgto.sem-dialog > .titulo > .cpnt-app-toggle {
      width: calc(100% - 110px - 130px) !important;
      max-width: 100px !important;
      margin-right: 5px;
    }
.dem-edi-pro-doc-pag--informar {
  width: 120px;
  vertical-align: 0px;
  margin-left: 5px;
}

.dem-edi-pro-doc-pag {
  width: 100%;
}
  .dem-edi-pro-doc-pag > tbody > tr > td.titulo {
    font-weight: 600;
    text-align: left;
    width: calc(100% - 140px);
    font-size: var(--font-base-soma-18);
  }
    .dem-edi-pro-doc-pag > tr > td.sem-pagamento > div,
    .dem-edi-pro-doc-pag > tbody > tr > td.troco > div,
    .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div.campos,
    .calc-troco {
      background: #efefef;
      border: 1px solid #c6c4c4;
      padding: 5px 10px;
      border-radius: 5px;
    }
    .dem-edi-pro-doc-pag > tbody > tr > td.conteudo {
      max-width: 100%;
    }
    .dem-edi-pro-doc-pag > tbody > tr > td.troco > div {
      float: right;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
      border-bottom: none;
      cursor: pointer;
    }
    .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div.campos {
      border-top-right-radius: 0;
    }

    .dem-edi-pro-doc-pag > tbody > tr > td.conteudo {
      }
      /* .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div.campos > div {
        width: calc(125px + 220px + 10px);
      }
      .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div.campos > div.com-vencimento {
        width: calc(125px + 220px + 100px + 20px);
      }
      .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div.campos > div {
        margin: 0px auto;
        padding-top: 20px;
      }
      .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div.campos > div:not(:first-child) {
        padding-top: 22px;
      }
        .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div.campos > div > .dem-edi-pro-doc-pag--valor,
        .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div.campos > div.com-vencimento > .dem-edi-pro-doc-pag--id_pgto {
          margin-right: 10px;
        } */
        .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div > div.inserir,
        .calc-troco > table > tr > td > div.inserir {
          padding-top: 10px;
          text-align: center;
        }

    .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div > div > .dem-edi-pro-doc-pag--valor {
      width: 125px;
    }
    .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div > div > .dem-edi-pro-doc-pag--id_pgto {
      width: 220px;
    }
    .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div > div > .dem-edi-pro-doc-pag--dup_vcto {
      width: 100px;
    }

  .dem-edi-pro-doc-pag > tbody > tr > td.conteudo > div {
    margin-bottom: 10px;
  }


    .dem-edi-pro-doc-pag-tab-tit {
      vertical-align: middle;
      font-size: 13px;
      text-align: center;
      line-height: 30px;
      color: #3875A5;
    }
      .dem-edi-pro-doc-pag-tab-tit > button {
        float: right;
        margin: 5px;
      }

  .calc-troco > table {
    width: 100%;
  }
    .calc-troco > table > tr:first-child > td {
      padding-top: 15px;
    }
    .calc-troco > table > tr:first-child > td:first-child {
      padding-right: 15px;
    }

    .dem-edi-pro-doc-pag > tr > td.sem-pagamento > div {
      text-align: center;
    }

  .dem-edi-pro-doc-pag ~ .botoes {
    padding-top: 22px;
    text-align: center;
  }
    .dem-edi-pro-doc-pag ~ .botoes > button {
      margin: 0px 5px;
      min-width: 100px;
    }
</style>

<style>
  .dem-edi-pro-doc-pag > tr > td.sem-pagamento > div > span > img {
    width: 50px;
    height: 50px;
    margin-bottom: 20px;
  }

  .dem-edi-pro-doc-pag-tab,
  .dem-edi-pro-doc-pag-tab > thead > tr > td,
  .dem-edi-pro-doc-pag-tab > thead > tr > th,
  .dem-edi-pro-doc-pag-tab > tbody > tr > td {
    font-size: 13px !important;
  }
  .dem-edi-pro-doc-pag-tab > tbody > tr > td {
    padding: 8px 5px !important;
  }
</style>

<script>
  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      // dados.virtual_total: {
      //   required: true
      // },
      // cpntDemData: {
      //   required: true
      // },
      // dados.virtual_p_doc_acao: {
      //   required: true
      // },
      // cpntPDocFiscal: {
      //   required: true
      // },
      // cpntPDocNFEmitida: {
      //   required: true
      // },
      // cpntPDocTp: {
      //   required: true
      // },
      cpntPDocDocs: {
        required: true
      },

      cpntFecharFormulario: {
        required: false
      }
    },
    components: {
      'App-Financeiro-Registrar-Receita-Despesa': () => import('@/components/financeiro/Registrar/Financeiro-Registrar-Receita-Despesa.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        aba: '',
        valores: {},
        campos: {
          informar: {
            id: 'dem-edi-pro-doc-pag--informar',
            status: '',
            nome: '',
            value: true,
            salvo: '',
            onChange: this.demEdiProDocPagOnChangeValue
          },
          valor: {
            id: 'dem-edi-pro-doc-pag--valor',
            status: '',
            nome: 'Valor pago',
            mask: 'valorMoeda',
            apiEnv: 'valor',
            value: '',
            onChange: this.demEdiProDocPagOnChangeValue
          },
          id_pgto: {
            id: 'dem-edi-pro-doc-pag--id_pgto',
            status: '',
            nome: 'Tipo pagamento',
            keyValue: 'id',
            keyMostra: [ 'id', ' - ', 'nome' ],
            options: [],
            apiEnv: 'id_pgto',
            value: { id: '1', nome: 'Dinheiro' },
            troco: true,
            onBuscarOptions: this.demEdiProDocPagBuscarTipoPagamento,
            onChange: this.demEdiProDocPagOnChangeValue
          },
          dup_vcto: {
            id: 'dem-edi-pro-doc-pag--dup_vcto',
            status: '',
            nome: 'Vencimento',
            apiEnv: 'dup_vcto',
            value: '',
            mostrar: false,
            onChange: this.demEdiProDocPagOnChangeValue
          },
          recebido: {
            id: 'dem-edi-pro-doc-pag--recebido',
            status: '',
            nome: 'Valor recebido',
            mask: 'valorMoeda',
            value: '',
            onChange: this.demEdiProDocPagOnChangeValue
          },
          troco: {
            id: 'dem-edi-pro-doc-pag--troco',
            status: '',
            nome: 'Troco',
            mask: 'valorMoeda',
            apiEnv: 'troco',
            disabled: true,
            value: '0,00',
            onChange: this.demEdiProDocPagOnChangeValue
          },
        },
        botoes: {
          inserir: {
            status: '',
            id: 'dem-edi-pro-doc-pag--inserir',
            texto: 'Inserir pagamento',
            class: [ 'btn', 'btn-primary', 'btn-sm' ],
            mostrar: true,
            onClick: () => { this.demEdiProDocPagInserirPagamento() }
          }
        },
        previsualizar: '',
        mostrarTroco: false,
        totais: {
          pago: 0,
          _pago: '0,00',
          recebido: 0,
          _recebido: '0,00',
          troco: 0,
          _troco: '0,00',
          faltante: null,
          _faltante: '0,00'
        },
        checkbox: [],
        route: '',
        method: 'POST',
        colunas: [],
        linha: [],
        where: {},
        order: { id: 'asc' },
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order', 'SemPaginacao' ]
        ],
        callback: null,
        botaoExcluir: undefined,
        dados: null
      }
    },
    mounted: function () {
      this.demEdiProDocPagIniciar()
    },
    methods: {
      demEdiProDocPagIniciar: function () {
        // SETA O STATUS DA TELA
        this.demEdiProDocPagSetarStatusGeral('carregando')

        // FAZ A BUSCA DOS DADOS NA API
        this.demEdiProDocPagBuscarValores(() => {  
          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'compra':
              this.route = '/demanda/dem-compra/dem-produto/df/pagamento/get'
              break
  
            case 'venda':
              this.route = '/venda/produto/df/pagamento/get'
              break
          }
  
          // CHAMA A FUNÇÃO PARA INICIAR A TABELA
          this.demEdiProDocPagTabBuscarLinhas(() => {
            // LIMPA O CAMPO 
            this.callback = null
  
            // CHAMA A FUNÇÃO PARA VERIFICAR SE DEVE MOSTRAR TROCO
            this.demEdiProDocPagVerificarMostraTroco()
  
            // CHAMA A FUNÇÃO PARA VERIFICAR SE DEVE MOSTRAR O VENCIMENTO
            this.demEdiProDocPagVerificarMostraVencimento()
  
            // REALIZA O FOCUS NO CAMPO SOLICITADO
            this.demEdiProDocPagRealizarFocusCampo('valor')
  
            // SETA O STATUS DA TELA
            this.demEdiProDocPagSetarStatusGeral('')
          })
        })
      },
      demEdiProDocPagBuscarValores: function (callback = null) {
        // INICIA O TIPO
        var router = ''
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 } }

        // VERIFICA O WHERE QUE DEVE REALIZAR
        switch (this.cpntDemanda) {
          case 'venda':
            // SETA A ROTA QUE DEVE BUSCAR
            router = '/venda/get'

            // SETA OS FIELDS VIRTUAL QUE DEVE CHAMAR
            queryGet.field_virtual = [ 'total' ]

            // SETA OS CAMPOS QUE DEVE BUSCAR
            queryGet.field = {
              cod_venda: null,
              p_doc_tp: null,
              vencimento: null
            }

            // SETA A QUERY QUE DEVE FAZER
            queryGet.where = { aAnd: [
              { f: 'status', o: '<>', v: '3' },
              { f: 'cod_venda', o: '=', v: this.cpntDemandaId }
            ] }
            break

          case 'compra':
            // SETA A ROTA QUE DEVE BUSCAR
            router = '/demanda/dem-compra/get'

            // SETA OS FIELDS VIRTUAL QUE DEVE CHAMAR
            queryGet.field_virtual = [ 'total' ]

            // SETA OS CAMPOS QUE DEVE BUSCAR
            queryGet.field = {
              dem_compra: null,
              p_doc_tp: null,
              vencimento: null
            }

            // SETA A QUERY QUE DEVE FAZER
            queryGet.where = { aAnd: [
              { f: 'dem_status', o: '<>', v: '3' },
              { f: 'dem_compra', o: '=', v: this.cpntDemandaId }
            ] }
            break

          case 'dev_cliente':
            // SETA A ROTA QUE DEVE BUSCAR
            router = '/demanda/dem-dev-cliente/get'

            // SETA OS FIELDS VIRTUAL QUE DEVE CHAMAR
            queryGet.field_virtual = [ 'total' ]

            // SETA OS CAMPOS QUE DEVE BUSCAR
            queryGet.field = {
              dem_dev_cliente: null,
              p_doc_tp: null,
              vencimento: null
            }

            // SETA A QUERY QUE DEVE FAZER
            queryGet.where = { aAnd: [
              { f: 'status', o: '<>', v: '3' },
              { f: 'dem_dev_cliente', o: '=', v: this.cpntDemandaId }
            ] }
            break

          case 'dev_fornecedor':
            // SETA A ROTA QUE DEVE BUSCAR
            router = '/demanda/dem-dev-fornecedor/get'

            // SETA OS FIELDS VIRTUAL QUE DEVE CHAMAR
            queryGet.field_virtual = [ 'total' ]

            // SETA OS CAMPOS QUE DEVE BUSCAR
            queryGet.field = {
              dem_dev_fornecedor: null,
              p_doc_tp: null,
              vencimento: null
            }

            // SETA A QUERY QUE DEVE FAZER
            queryGet.where = { aAnd: [
              { f: 'status', o: '<>', v: '3' },
              { f: 'dem_dev_fornecedor', o: '=', v: this.cpntDemandaId }
            ] }
            break
        }

        // VERIFICA SE TEM O PACOTE PRODUTO
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, null, null, null, null, false) === true) {
          queryGet.field_virtual = queryGet.field_virtual.concat([ 'p_doc_acao' ])
        }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI(router, 'POST', queryGet, (retorno) => {
          if ([ '', null, undefined ].indexOf(retorno.data) !== -1 || Object.keys(retorno.data).length === 0) {
            switch (this.cpntDemanda) {
              case 'venda':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.msgWarn('WEB [406]: Venda (' + this.cpntDemandaMask + ') informada não foi localizada.', 'warning')
    
                // ALTERA PARA TELA DE VENDAS GERENCIAR
                this.$router.push({ name: 'vendas_gerenciar' })
                break

              case 'compra':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.msgWarn('WEB [406]: Compra (' + this.cpntDemandaMask + ') informada não foi localizada.', 'warning')
    
                // ALTERA PARA TELA DE VENDAS GERENCIAR
                this.$router.push({ name: 'compras_gerenciar' })
                break

              case 'dev_cliente':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.msgWarn('WEB [406]: Devolução do cliente (' + this.cpntDemandaMask + ') informada não foi localizada.', 'warning')
    
                // ALTERA PARA TELA DE VENDAS GERENCIAR
                this.$router.push({ name: 'dev_cliente_gerenciar' })
                break

              case 'dev_fornecedor':
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.msgWarn('WEB [406]: Devolução do fornecedor (' + this.cpntDemandaMask + ') informada não foi localizada.', 'warning')
    
                // ALTERA PARA TELA DE VENDAS GERENCIAR
                this.$router.push({ name: 'dev_fornecedor_gerenciar' })
                break

              default:
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.msgWarn('WEB [406]: Demanda (' + this.cpntDemanda + ') com numerção (' + this.cpntDemandaMask + ') não foi localizada.', 'warning')
    
                // ALTERA PARA TELA DE VENDAS GERENCIAR
                this.$router.push({ name: 'inicio' })
                break
            }
          } else {
            // PEGA O VALOR RECEBIDO
            retorno = retorno.data[0]

            // SETA O VALOR RECEBIDO
            retorno.dem_data_ptbr = retorno.vencimento_ptbr

            // SETA OS VALORES NO CAMPO
            retorno.virtual_p_doc_acao = Object.assign({
            cancelar: '0',
            consultar: '0',
            danfe: '0',
            emitir: '0',
            inutilizar: '0',
            reemitir: '0',
            rejeicao: '0',
            salvar: '1',
            contingencia: '0'
          }, retorno.virtual_p_doc_acao)

            // VERIFICA SE TEM NOTA EMITIDA
            if ([ '', null, undefined ].indexOf(retorno.virtual_p_doc_acao) === -1) {
              retorno.nfEmitida = (retorno.virtual_p_doc_acao.salvar === '0')
            }

            // FORMATA OS VALORES RECEBIDOS
            for (var indexT in retorno.virtual_total) {
              for (var indexC in retorno.virtual_total[indexT]) {
                switch (indexC) {
                  case 'creDevolucao':
                  case 'desconto':
                  case 'liquido':
                  case 'retencao':
                  case 'frete':
                  case 'oda':
                  case 'seguro':
                  case 'total':
                  case 'taxa':
                    retorno.virtual_total[indexT]['_' + indexC] = this.$store.state.FUN_MASK_VALOR('valorMoeda', retorno.virtual_total[indexT][indexC])
                    break
                }
              }
            }

            // SETA OS DADOS NO VETOR 
            this.dados = retorno

            // SETA OS DADOS CARREGADOS NA DIALOG
            this.$emit('SETAR_DADOS_DIALOG_PGTO', retorno)

            // EXECUTA O CALLBACK RECEBIDO
            if (callback !== null && typeof callback === 'function') {
              callback()
            }
          }
        }, this.demEdiProDocPagSetarStatusGeral)

      },
      demEdiProDocPagFechar: function (atualizar = false) {
        if (this.campos.informar.value === false && [ '', null, undefined ].indexOf(this.campos.informar.salvo) === -1 && this.linha.filter(item => item.id_pgto !== '0').length >= 1) {
          // ADICIONA O ID AO VETOR DE CHECKBOX
          this.checkbox = JSON.parse(JSON.stringify(this.campos.informar.salvo))

          // LIMPA O CALLBACK
          this.callback = null

          // LIMPA O CALLBACK
          this.linha = []
          
          // DELETA OS CAMPOS
          this.demEdiProDocPagTabExcluir(() => { this.demEdiProDocPagInserirSemPagamento(() => { this.demEdiProDocPagTabBuscarLinhas(() => { this.demEdiProDocPagFechar(atualizar) }) }) })
        } else if (this.campos.informar.value === false && [ '', null, undefined ].indexOf(this.campos.informar.salvo) !== -1) {
          this.demEdiProDocPagInserirSemPagamento(() => { this.demEdiProDocPagTabBuscarLinhas(() => { this.demEdiProDocPagFechar(atualizar) }) })
        } else {
          if (this.$route.name === 'venda_numero_pgto') {
            this.$router.push({ name: 'demanda_tipo_numero', params: { tipo: this.cpntDemanda, id: this.cpntDemandaId, demProDocPag: atualizar } })
          } else {
            this.cpntFecharFormulario(atualizar)
          }
        }
      },
      demEdiProDocPagSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocPagRealizarFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.demEdiProDocPagRealizarFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      demEdiProDocPagBuscarTipoPagamento: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, order: { id: 'asc' } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, nome: null }

          // REMOVE PAGAMENTOS OUTROS
          queryGet.where = { f: 'id_pgto_df', o: '<>', v: '99' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/financeiro/config/for-pagamento/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProDocPagBuscarTipoPagamento(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.id_pgto.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.id_pgto.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProDocPagOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // SETA O VALOR RECEBIDO
        this.$set(this.campos[indexF[1]], 'value', value)

        // LIMPA O CAMPO DE MENSAGEM DE ERRO
        this.$set(this.campos[indexF[1]], 'mensagem', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF[1]) {
          case 'informar':
            var finaliza = () => {
              if (this.campos.informar.value === false) {
                this.demEdiProDocPagInserirSemPagamento(() => { this.demEdiProDocPagTabBuscarLinhas() })
              } else {
                this.demEdiProDocPagTabBuscarLinhas()
              }
            }

            // VERIFICA SE TEM PAGAMENTO INSERIDO
            if ([ '', null, undefined ].indexOf(this.campos.informar.salvo) === -1) {
              // ADICIONA O ID AO VETOR DE CHECKBOX
              this.checkbox = JSON.parse(JSON.stringify(this.campos.informar.salvo))

              // LIMPA O CALLBACK
              this.callback = null

              // DELETA OS CAMPOS
              this.demEdiProDocPagTabExcluir(() => {
                // LIMPA O VETOR 
                this.checkbox = []

                // LIMPA O VALOR DA VARIAVEL
                this.campos.informar.salvo = ''

                // EXECUTA A FUNÇÃO PARA FINALIZAÇÃO
                finaliza()
              })
            } else {
              finaliza()
            }

            // if (this.campos.informar.value === true && [ '', null, undefined ].indexOf(this.campos.informar.salvo) === -1) {
            //   // ADICIONA O ID AO VETOR DE CHECKBOX
            //   this.checkbox = JSON.parse(JSON.stringify(this.campos.informar.salvo))

            //   // LIMPA O CALLBACK
            //   this.callback = null
              
            //   // DELETA OS CAMPOS
            //   this.demEdiProDocPagTabExcluir(() => {})
            // }
            break

          case 'id_pgto':
            // PEGA O VALOR SELECIONADO
            var id_pgto = (value === 'string' ? value : value.id)

            // CHAMA A FUNÇÃO PARA VERIFICAR SE DEVE MOSTRAR TROCO
            this.demEdiProDocPagVerificarMostraTroco(id_pgto)

            // CHAMA A FUNÇÃO PARA VERIFICAR SE DEVE MOSTRAR O VENCIMENTO
            this.demEdiProDocPagVerificarMostraVencimento(id_pgto)

            // REALIZA O FOCUS NO CAMPO SOLICITADO
            switch (id_pgto) {
              case '3':
                this.demEdiProDocPagRealizarFocusCampo('dup_vcto')
                break

              case '1':
                this.demEdiProDocPagCalcularValorTroco()
                break
            }
            break

          case 'recebido':
            this.demEdiProDocPagCalcularValorTroco()
            break
        }
      },
      demEdiProDocPagVerificarMostraTroco: function (id_pgto = null) {
        // PEGA O VALOR SELECIONADO
        if (id_pgto === null) {
          id_pgto = (this.campos.id_pgto.value === 'string' ? this.campos.id_pgto.value : this.campos.id_pgto.value.id)
        }

        // VERIFICA SE DEVE MOSTRAR O TROCO
        this.$set(this.campos.id_pgto, 'troco', [ '1' ].indexOf(id_pgto) !== -1)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocPagVerificarMostraVencimento: function (id_pgto = null) {
        // PEGA O VALOR SELECIONADO
        if (id_pgto === null) {
          id_pgto = (this.campos.id_pgto.value === 'string' ? this.campos.id_pgto.value : this.campos.id_pgto.value.id)
        }

        // VERIFICA SE DEVE MOSTRAR O TROCO
        this.$set(this.campos.dup_vcto, 'mostrar', [ '3' ].indexOf(id_pgto) !== -1)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocPagCalcularValorTroco: function () {
        // PEGA O VALOR DO CAMPO
        var pago = this.totais.faltante

        // PEGA O VALOR DO CAMPO
        var recebido = this.campos.recebido.value

        // SETA O VALOR DO TROCO NO CAMPO
        this.campos.troco.value = (recebido - pago)
      },
      demEdiProDocPagInserirSemPagamento: function (callback) {
        // INICIA O VETOR
        var formData = { id_pgto: '0', valor: '0' }

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda + '_pgto_df')

        // SETA A DEMANDA 
        formData[chaveD] = this.cpntDemandaId

        // CONVERTE O FORMULARIO PARA LOT
        formData = { lot: [ formData ] }

        // SETA O NOME DA ROTA
        var route = ''

        // VERIFICA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda) {
          case 'compra':
            route = '/demanda/dem-compra/dem-produto/df/pagamento'
            break

          case 'venda':
            route = '/venda/produto/df/pagamento'
            break
        }

        // COMUNICA COM A API
        this.$store.state.comunicaAPI(route, 'POST', formData, (retorno) => {
          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.TRATAR_RET_LOT_API(retorno)

          // VERIFICA SE DEVE ABRIR A DIALOG DO TROCO
          this.mostrarTroco = false

          // MANDA ATUALIZAR O FINANCEIRO
          this.$parent.$emit('DEMANDA_ATUALIZAR_FINANCEIRO')

          // BUSCA OS DADOS
          this.demEdiProDocPagTabBuscarLinhas(callback)
        }, this.demEdiProDocPagSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiProDocPagTratarValidacao(apiValid, apiStatus) })
      },
      demEdiProDocPagInserirTroco: function (callback) {
        // INICIA O VETOR
        var formData = { id_pgto: '1', valor: this.campos.recebido.value }

        // VERIFICA SE TEM QUE ARRUMAR O VALOR DO CAMPO
        if ([ '', null, undefined ].indexOf(formData.valor) === -1) {
          // REMOVE O PONTO
          while (formData.valor.indexOf('.') !== -1) {
            formData.valor = formData.valor.replace('.', '')
          }

          // REMOVE A VIRGULA
          while (formData.valor.indexOf(',') !== -1) {
            formData.valor = formData.valor.replace(',', '')
          }
        }

        // SETA O VALOR DO TROCO
        formData.troco = this.campos.troco.value

        // VERIFICA SE TEM QUE ARRUMAR O VALOR DO CAMPO
        if ([ '', null, undefined ].indexOf(formData.troco) === -1) {
          // REMOVE O PONTO
          while (formData.troco.indexOf('.') !== -1) {
            formData.troco = formData.troco.replace('.', '')
          }

          // REMOVE A VIRGULA
          while (formData.troco.indexOf(',') !== -1) {
            formData.troco = formData.troco.replace(',', '')
          }
        }

        // SETA O VALOR CORRETO DO PAGAMENTO
        formData.valor = (Number(formData.valor) - Number(formData.troco)).toString()

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda + '_pgto_df')

        // SETA A DEMANDA 
        formData[chaveD] = this.cpntDemandaId

        // CONVERTE O FORMULARIO PARA LOT
        formData = { lot: [ formData ] }

        // SETA O NOME DA ROTA
        var route = ''

        // VERIFICA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda) {
          case 'compra':
            route = '/demanda/dem-compra/dem-produto/df/pagamento'
            break

          case 'venda':
            route = '/venda/produto/df/pagamento'
            break
        }

        // COMUNICA COM A API
        this.$store.state.comunicaAPI(route, 'POST', formData, (retorno) => {
          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.TRATAR_RET_LOT_API(retorno)

          // VERIFICA SE DEVE ABRIR A DIALOG DO TROCO
          this.mostrarTroco = false

          // MANDA ATUALIZAR O FINANCEIRO
          this.$parent.$emit('DEMANDA_ATUALIZAR_FINANCEIRO')

          // BUSCA OS DADOS
          this.demEdiProDocPagTabBuscarLinhas(callback)
        }, this.demEdiProDocPagSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiProDocPagTratarValidacao(apiValid, apiStatus) })
      },
      demEdiProDocPagInserirPagamento: function (vetor, callback, setarStatusBotao) {
        // SETA O STATUS DO BOTÃO
        setarStatusBotao('carregando')

        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda + '_pgto_df')

        // PEGA AS PARCELAS DO VETOR
        vetor = vetor.parcela

        // RODA O VETOR VERIFICANDO OS VALORES
        for (var index in vetor) {
          // VERIFICA SE TEM QUE INFORMAR A DUPLICADA
          if ([ '03', '3' ].indexOf(vetor[index].id_pgto) !== -1) {
            vetor[index].dup_vcto = vetor[index].vcto_pgto
          }
          
          // REMOVE A CHAVE INFORMADA 
          delete vetor[index].vcto_pgto
          
          // SETA A DEMANDA 
          vetor[index][chaveD] = this.cpntDemandaId
        }

        // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
        const finalizacao = (_callback = null) => {
          // VERIFICA SE DEVE ABRIR A DIALOG DO TROCO
          this.mostrarTroco = false

          // SETA OS VALORES RECEBIDOS
          setarStatusBotao('')

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          if (_callback !== null && typeof _callback === 'function') {
            _callback()
          }
        }

        // // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        // const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

        // // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        // FUN_MONTAR_FORMDATA_API(this.campos).then((formData) => {
        //   // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        //   const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        //   // PEGA A CHAVE REFERENCIA
        //   var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

        //   // VERIFICA SE DEVE INFORMAR SEM PAGAMENTO
        //   if (this.campos.informar.value === false) {
        //     formData = { id_pgto: '0', valor: '0' }
        //   }

        //   // SETA O CODIGO DA VENDA
        //   formData[chaveD] = this.cpntDemandaId

        //   // CONVERTE O VALOR DO CAMPO
        //   if ((this.mostrarTroco === true && [ '', null, undefined ].indexOf(formData.troco) === -1) === false) {
        //     delete formData.troco
        //   }

        //   // VERIFICA SE TEM QUE ARRUMAR O VALOR DO CAMPO
        //   if ([ '', null, undefined ].indexOf(formData.valor) === -1) {
        //     // REMOVE O PONTO
        //     while (formData.valor.indexOf('.') !== -1) {
        //       formData.valor = formData.valor.replace('.', '')
        //     }

        //     // REMOVE A VIRGULA
        //     while (formData.valor.indexOf(',') !== -1) {
        //       formData.valor = formData.valor.replace(',', '')
        //     }
        //   }

        //   // VERIFICA SE TEM QUE ARRUMAR O VALOR DO CAMPO
        //   if ([ '', null, undefined ].indexOf(formData.troco) === -1) {
        //     // REMOVE O PONTO
        //     while (formData.troco.indexOf('.') !== -1) {
        //       formData.troco = formData.troco.replace('.', '')
        //     }

        //     // REMOVE A VIRGULA
        //     while (formData.troco.indexOf(',') !== -1) {
        //       formData.troco = formData.troco.replace(',', '')
        //     }
        //   }

        // CONVERTE O FORMULARIO PARA LOT
        var formData = { lot: vetor }

        // SETA O NOME DA ROTA
        var route = ''

        // VERIFICA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda) {
          case 'compra':
            route = '/demanda/dem-compra/dem-produto/df/pagamento'
            break

          case 'venda':
            route = '/venda/produto/df/pagamento'
            break
        }

        // COMUNICA COM A API
        this.$store.state.comunicaAPI(route, 'POST', formData, (retorno) => {
          // APRESENTA A MENSAGEM DE SUCESSO
          this.$store.state.TRATAR_RET_LOT_API(retorno)

          // MANDA ATUALIZAR O FINANCEIRO
          this.$parent.$emit('DEMANDA_ATUALIZAR_FINANCEIRO')

          // EXECUTA A FUNÇÃO DE FINALIZAÇÃO
          finalizacao(() => {
            // // SETA O FOCUS NO CAMPO
            // this.demEdiProDocPagRealizarFocusCampo('valor')

            // RECARREGA A TABELA COM OS DADOS LOCALIZADOS
            this.demEdiProDocPagTabBuscarLinhas(() => {
              this.linha.valor
            })
          })
        }, this.demEdiProDocPagSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiProDocPagTratarValidacao(apiValid, apiStatus, finalizacao) })
        // })
      },
      // demEdiProDocPagInserirPagamento: function (callback = null) {
      //   // SETA OS VALORES RECEBIDOS
      //   this.$set(this.botoes.inserir, 'status', 'carregando')

      //   // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //   this.time = new Date().getTime()

      //   // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
      //   const finalizacao = (_callback = null) => {
      //     // VERIFICA SE DEVE ABRIR A DIALOG DO TROCO
      //     this.mostrarTroco = false

      //     // SETA OS VALORES RECEBIDOS
      //     this.$set(this.botoes.inserir, 'status', '')

      //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      //     this.time = new Date().getTime()

      //     // EXECUTA A FUNÇÃO CALLBACK
      //     if (_callback !== null && typeof _callback === 'function') {
      //       _callback()
      //     }
      //   }

      //   // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
      //   const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API

      //   // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
      //   FUN_MONTAR_FORMDATA_API(this.campos).then((formData) => {
      //     // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
      //     const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

      //     // PEGA A CHAVE REFERENCIA
      //     var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

      //     // VERIFICA SE DEVE INFORMAR SEM PAGAMENTO
      //     if (this.campos.informar.value === false) {
      //       formData = { id_pgto: '0', valor: '0' }
      //     }

      //     // SETA O CODIGO DA VENDA
      //     formData[chaveD] = this.cpntDemandaId

      //     // CONVERTE O VALOR DO CAMPO
      //     if ((this.mostrarTroco === true && [ '', null, undefined ].indexOf(formData.troco) === -1) === false) {
      //       delete formData.troco
      //     }

      //     // VERIFICA SE TEM QUE ARRUMAR O VALOR DO CAMPO
      //     if ([ '', null, undefined ].indexOf(formData.valor) === -1) {
      //       // REMOVE O PONTO
      //       while (formData.valor.indexOf('.') !== -1) {
      //         formData.valor = formData.valor.replace('.', '')
      //       }

      //       // REMOVE A VIRGULA
      //       while (formData.valor.indexOf(',') !== -1) {
      //         formData.valor = formData.valor.replace(',', '')
      //       }
      //     }

      //     // VERIFICA SE TEM QUE ARRUMAR O VALOR DO CAMPO
      //     if ([ '', null, undefined ].indexOf(formData.troco) === -1) {
      //       // REMOVE O PONTO
      //       while (formData.troco.indexOf('.') !== -1) {
      //         formData.troco = formData.troco.replace('.', '')
      //       }

      //       // REMOVE A VIRGULA
      //       while (formData.troco.indexOf(',') !== -1) {
      //         formData.troco = formData.troco.replace(',', '')
      //       }
      //     }

      //     // CONVERTE O FORMULARIO PARA LOT
      //     formData = { lot: [ formData ] }

      //     // SETA O NOME DA ROTA
      //     var route = ''

      //     // VERIFICA A ROTA QUE DEVE CHAMAR
      //     switch (this.cpntDemanda) {
      //       case 'compra':
      //         route = '/demanda/dem-compra/dem-produto/df/pagamento'
      //         break

      //       case 'venda':
      //         route = '/venda/produto/df/pagamento'
      //         break
      //     }

      //     // COMUNICA COM A API
      //     this.$store.state.comunicaAPI(route, 'POST', formData, (retorno) => {
      //       // APRESENTA A MENSAGEM DE SUCESSO
      //       this.$store.state.TRATAR_RET_LOT_API(retorno)

      //       // MANDA ATUALIZAR O FINANCEIRO
      //       this.$parent.$emit('DEMANDA_ATUALIZAR_FINANCEIRO')

      //       // VERIFICA SE TEM CALLBACK A EXECUTAR
      //       if (callback !== null && typeof callback === 'function') {
      //         // EXECUTA O CALLBAK
      //         callback()

      //         // FINALIZA O PROCESSO
      //         finalizacao()
      //       } else {
      //         finalizacao(() => {
      //           // SETA O FOCUS NO CAMPO
      //           this.demEdiProDocPagRealizarFocusCampo('valor')

      //           // RECARREGA A TABELA COM OS DADOS LOCALIZADOS
      //           this.demEdiProDocPagTabBuscarLinhas()
      //         })
      //       }
      //     }, this.demEdiProDocPagSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiProDocPagTratarValidacao(apiValid, apiStatus, finalizacao) })
      //   })
      // },
      demEdiProDocPagTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.inserir.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      demEdiProDocPagTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 10) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.demEdiProDocPagTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      demEdiProDocPagTabBuscarLinhas: function (callback = null) {
        // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
        const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

        // PEGA A CHAVE REFERENCIA
        var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

        // VERIFICA SE PODE EXCLUIR VENDA OU NÃO
        this.botaoExcluir = this.demEdiProDocPagTabExcluir

        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [ { f: chaveD, o: '=', v: this.cpntDemandaId }, { f: 'status', o: '=', v: '1' } ] }

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 2,  chave: 'id_pgto_nome',  nome: 'Tipo Pagamento',   fieldsApi: { id_pgto: { j: { nome: null } } } },
          { mPer: 2,  chave: 'pago',          nome: 'Valor Pago',       fieldsApi: { valor: null } },
          { mPer: 2,  chave: 'recebido',      nome: 'Valor Recebido',   fieldsApi: { troco: null } },
          { mPer: 2,  chave: 'dup_vcto',      nome: 'Duplicata Vcto',   fieldsApi: { dup_vcto: null } },
          { mPer: 3,  chave: 'id',                                      fieldsApi: { id: null }, tipo: 'checkbox' }
        ]

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var remover = []

        // REMOVE A COLUNA SE JÁ TIVER NOTA EMITIDA
        if (this.dados.nfEmitida === true) {
          remover.push('id')
        }

        // REMOVE AS COLUNAS INFORMADAS
        if (remover.length >= 1) {
          colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // SETA O CALLBACK QUE DEVE REALIZAR
        this.callback = callback

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
          this.demEdiProDocPagTabReiniciar()
        } else {
          this.demEdiProDocPagSetarStatusGeral('')
        }
      },
      demEdiProDocPagTabSetarLinhas: function (vetor) {
        // VERIFICA SE A VENDA É SEM PAGAMENTO
        if (vetor.length === 1 && vetor[0].id_pgto === '0') {
          // ALTERA O VALOR
          this.campos.informar.value = false

          // ALTERA O VALOR
          this.campos.informar.salvo = [ vetor[0].id ]

          // SETA OS VALORES RECEBIDOS
          this.linha = []

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA O CALLBACK RECEBIDO
          if (this.callback !== null && typeof this.callback === 'function') {
            this.callback()
          }
        } else {
          // INICIA AS VARIAVEIS
          this.totais.pago = 0
          this.totais.recebido = 0
          this.totais.troco = 0
          // PEGA O VALOR QUE DEVE FORMATAR
          var liquido = '0'
          var creDevolucao = '0'
          
          // VERIFICA SE TEM A CHAVE PRODUTO
          if ([ '', null, undefined ].indexOf(this.dados.virtual_total.produto) === -1) {
            // SETA O VALOR LIQUIDO
            liquido = this.dados.virtual_total.produto.liquido
            
            // VERIFICA SE TEM A CHAVE DE CREDITO
            if ([ '', null, undefined ].indexOf(this.dados.virtual_total.produto.creDevolucao) === -1) {
              creDevolucao = this.dados.virtual_total.produto.creDevolucao
            }
          } else {
            // SETA O VALOR LIQUIDO
            liquido = this.dados.virtual_total.liquido
            
            // VERIFICA SE TEM A CHAVE DE CREDITO
            if ([ '', null, undefined ].indexOf(this.dados.virtual_total.creDevolucao) === -1) {
              creDevolucao = this.dados.virtual_total.creDevolucao
            }
          }

          // VERIFICA SE TEM CREDITO A SER LANÇADO COMO PAGAMENTO
          if ([ '', null, undefined, '0', '0,00', '0.00' ].indexOf(creDevolucao) === -1) {
            vetor.unshift({
              id: '',
              id_pgto: '',
              id_pgto_nome: 'Crédito Loja',
              dup_vcto_ptbr: '',
              valor: creDevolucao,
              troco: '',
              _disabled_checkbox: true
            })
          }

          // INICIA A VARIAVEL IDS
          var ids = []

          // ALTERA O VALOR
          this.campos.informar.value = true

          // TRATA OS VALORES DE TODOAS AS LINHAS
          for (var indexV in vetor) {
            // SETA O ID RECEBIDO
            ids.push(vetor[indexV].id)

            // CONVERTE O CAMPO EM NUMERO
            vetor[indexV].valor = Number(vetor[indexV].valor)
            vetor[indexV].troco = Number(vetor[indexV].troco)
  
            // CALCULA O VALOR RECEBIDO
            vetor[indexV].valor_recebido = vetor[indexV].valor + vetor[indexV].troco
  
            // SOMA OS VALORES NOS TOTAIS
            this.totais.pago      += vetor[indexV].valor
            this.totais.recebido  += vetor[indexV].valor_recebido
            this.totais.troco     += vetor[indexV].troco
  
            // FORMATA OS VALORES
            vetor[indexV]._valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', vetor[indexV].valor.toString())
            vetor[indexV]._valor_recebido = this.$store.state.FUN_MASK_VALOR('valorMoeda', vetor[indexV].valor_recebido.toString())
            vetor[indexV]._troco = this.$store.state.FUN_MASK_VALOR('valorMoeda', vetor[indexV].troco.toString())
          }

          // ALTERA O VALOR
          this.campos.informar.salvo = ids.length >= 1 ? ids : ''

  
          // CALCULA O TOTAL FALTANTE
          if ([ 'venda', 'compra' ].indexOf(this.cpntDemanda) !== -1) {
            this.totais.faltante = ((Number(liquido) + Number(creDevolucao)) - this.totais.pago)
          } else {
            this.totais.faltante = (Number(liquido) - this.totais.pago)
          }
  
          // FORMATA OS VALORES
          this.totais._pago = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.totais.pago.toString())
          this.totais._recebido = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.totais.recebido.toString())
          this.totais._troco = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.totais.troco.toString())
          this.totais._faltante = this.$store.state.FUN_MASK_VALOR('valorMoeda', this.totais.faltante.toString())
  
          // SETA O VALOR FALTANTE NO CAMPO PARA PAGAMENTO
          this.campos.valor.value = this.totais._faltante
  
          // SETA OS VALORES RECEBIDOS
          this.linha = vetor

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA O CALLBACK RECEBIDO
          if (this.callback !== null && typeof this.callback === 'function') {
            this.callback()
          }
        }
      },
      demEdiProDocPagTabMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocPagTabExcluir: function (callback = null) {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (this.checkbox.length === 0) {
          if (callback !== null) {
            callback()
          } else {
            this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
          }
        } else if (callback !== null || window.confirm('Deseja realmente excluir o(s) pagamento(s) selecionados?')) {
          // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
          const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

          // PEGA A CHAVE REFERENCIA
          var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoExcluir = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { lot: [] }

          // SETA OS CAMPOS QUE DEVEM SER EXCLUIDOS
          for (var indexC in this.checkbox) {
            // INICIA O VETOR
            var item = { id: this.checkbox[indexC] }

            // SETA A DEMANDA
            item[chaveD] = this.cpntDemandaId

            // ADICIONA O VALOR NO VETOR
            formData.lot.push(item)
          }
          
          // SETA O NOME DA ROTA
          var route = ''

          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'compra':
              route = '/demanda/dem-compra/dem-produto/df/pagamento'
              break

            case 'venda':
              route = '/venda/produto/df/pagamento'
              break
          }

          // COMUNICA COM A API
          this.$store.state.comunicaAPI(route, 'DELETE', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                // LIMPA O CALLBACK
                this.callback = null

                // MANDA ATUALIZAR O FINANCEIRO
                this.$parent.$emit('DEMANDA_ATUALIZAR_FINANCEIRO')

                // MANDA ATUALIZAR A TABELA
                if (callback !== null && typeof callback === 'function') {
                  callback()
                } else {
                  // SETA O FOCUS NO CAMPO
                  this.demEdiProDocPagRealizarFocusCampo('valor')

                  // RECARREGA A TABELA COM OS DADOS LOCALIZADOS
                  this.demEdiProDocPagTabBuscarLinhas()
                }
                break

              default:
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
                break
            }

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoExcluir = this.demEdiProDocPagTabExcluir

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.demEdiProDocPagSetarStatusGeral)
        }
      },
      demEdiProDocPagAtalhoTroco: function () {
        // VERIFICA SE DEVE ABRIR A DIALOG DO TROCO
        this.mostrarTroco = (this.mostrarTroco === false && this.campos.id_pgto.troco === true && this.totais.faltante > 0)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE ESTÁ ABRINDO O CAMPO
        if (this.mostrarTroco === true) {
          // CALCULA O VALOR DO TROCO
          this.demEdiProDocPagCalcularValorTroco()

          // SETA O FOCUS NO CAMPO
          this.demEdiProDocPagRealizarFocusCampo('recebido')
        }
      },
      demEdiProDocPreVisualizarFechar: function () {
        // SETA OS VALORES RECEBIDOS
        this.previsualizar = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocPreVisualizar: function () {
        if (this.campos.informar.value === false && [ '', null, undefined ].indexOf(this.campos.informar.salvo) === -1 && this.linha.filter(item => item.id_pgto !== '0').length >= 1) {
          // ADICIONA O ID AO VETOR DE CHECKBOX
          this.checkbox = JSON.parse(JSON.stringify(this.campos.informar.salvo))

          // LIMPA O CALLBACK
          this.callback = null

          // LIMPA O CALLBACK
          this.linha = []
          
          // DELETA OS CAMPOS
          this.demEdiProDocPagTabExcluir(() => { this.demEdiProDocPagInserirSemPagamento(() => { this.demEdiProDocPagTabBuscarLinhas(() => { this.demEdiProDocPreVisualizar() }) }) })
          
        } else if (this.campos.informar.value === false && [ '', null, undefined ].indexOf(this.campos.informar.salvo) !== -1) {
          this.demEdiProDocPagInserirSemPagamento(() => { this.demEdiProDocPagTabBuscarLinhas(() => { this.demEdiProDocPreVisualizar() }) })
        } else {
          // SETA OS VALORES RECEBIDOS
          this.previsualizar = 'carregando'
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
  
          // INICIA AS VARIAVEIS
          var router = ''
          var method = ''
          var formData = {}
  
          // VERIFICA SE DEVE REEMITIR OU EMITIR
          switch (this.dados.virtual_p_doc_acao.emitir === '1') {
            case true:
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/df/emitir'
  
              // SETA O METHOD QUE DEVE CHAMAR
              method = 'POST'

              // VERIFICA A DEMANDA QUE DEVE REALIZAR
              switch (this.cpntDemanda) {
                case 'venda':
                  formData = { j_ref: JSON.stringify([ { tp: 'p', m: '10', id: this.cpntDemandaId } ]) }
                  break
              
                case 'dev_cliente':
                  formData = { j_ref: JSON.stringify([ { tp: 'p', m: '59', id: this.cpntDemandaId } ]) }
                  break

                case 'compra':
                  formData = { j_ref: JSON.stringify([ { tp: 'p', m: '11', id: this.cpntDemandaId } ]) }
                  break
              }
              break
  
            default:
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/df/reemitir'
  
              // SETA O METHOD QUE DEVE CHAMAR
              method = 'PUT'
  
              // SETA O ID DO DOC_FISCAL
              formData = { j_df: JSON.stringify([ this.cpntPDocDocs ]) }
              break
          }
  
          // SETA O LAG QUE DEVE SER PREVISUALIZAÇÃO
          formData.pre_visualizar = 'sim'
          
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, method, formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
  
            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEdiProDocPagFormTratarValidacao(retorno.message, retorno.code)
            } else {
              // SETA OS VALORES RECEBIDOS
              this.previsualizar = retorno.data
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          }, this.demEdiProDocPagSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiProDocPagFormTratarValidacao(apiValid, apiStatus) })
        }
      },
      demEdiProDocPagFormTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // SETA OS VALORES RECEBIDOS
          this.previsualizar = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      }
    },
    computed: {
      demEdiProDocPagValorLiquidoProduto: function () {
        // PEGA O VALOR QUE DEVE FORMATAR
        var liquido = '0'
        var creDevolucao = '0'
        
        // VERIFICA SE TEM A CHAVE PRODUTO
        if ([ '', null, undefined ].indexOf(this.dados.virtual_total.produto) === -1) {
          // SETA O VALOR LIQUIDO
          liquido = this.dados.virtual_total.produto.liquido
          
          // VERIFICA SE TEM A CHAVE DE CREDITO
          if ([ '', null, undefined ].indexOf(this.dados.virtual_total.produto.creDevolucao) === -1) {
            creDevolucao = this.dados.virtual_total.produto.creDevolucao
          }
        } else {
          // SETA O VALOR LIQUIDO
          liquido = this.dados.virtual_total.liquido
          
          // VERIFICA SE TEM A CHAVE DE CREDITO
          if ([ '', null, undefined ].indexOf(this.dados.virtual_total.creDevolucao) === -1) {
            creDevolucao = this.dados.virtual_total.creDevolucao
          }
        }

        // FORMATA OS NUMEROS
        return this.$store.state.FUN_MASK_VALOR('valorMoeda', (Number(liquido) + Number(creDevolucao)).toString())
      }
    }
  }
</script>
